<template>
<div id="contra">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <router-link class="breadcrumb-item" to="/avatamsaka/chooseContra">
        {{$t('avatamsaka.contrast.title')}}
      </router-link>
      <li class="breadcrumb-item active" aria-current="page" v-if="filteredSutraList.length">
        《{{$t('avatamsaka.sutras.sutra', {
          'noticeType': $t(`avatamsaka.sutras.sutra0${sutraId}books[${versionId-1}].text`)
        })}}》
      </li>
    </ol>
  </nav>

  <div class="topArea">
    <div>
      <input type="radio" id="one" value="paragraph" v-model="picked">
      <label for="one">
        {{$t('avatamsaka.articles.paragraph')}}
      </label>

      <input type="radio" id="two" value="phrase" v-model="picked">
      <label for="two">
        {{$t('avatamsaka.articles.phrase')}}
      </label>

    </div>
    <div>
      <input type="checkbox" v-model="read" true-value="yes"
      false-value="no" value="false" v-on:click="playOnIos" > {{$t('avatamsaka.articles.autoRead')}}

      <div class="hasNoSameTag" v-if="hasNoSameTag">
         {{$t('avatamsaka.articles.noTag')}}
      </div>
    </div>

  </div>
  <div class="content">
    <div id="left">
      <div class="mp3">
        <audio class="audioFile" ref="audioFileL"
        :src="mp3LinkL" controls="controls">
        </audio>
      </div>
      <componentBoTexts/>
    </div>
    <div class="hasNoSameTagMobile" v-if="hasNoSameTag">{{$t('avatamsaka.articles.noTag')}}</div>
    <div id="right" ref="right">
      <div class="mp3">
        <audio class="audioFile" ref="audioFileR"
        :src="mp3LinkR" controls>
        </audio>
      </div>
      <componentTexts/>
    </div>
  </div>

</div>
</template>

<script>

/* eslint-disable */
import Vue from 'vue';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'index',
  data() {
    return {
      picked: 'phrase',
      read: 'no',
      change: '<p>change it</p>',
    };
  },
  created () {
    const articlePath = this.articlePath + '.vue';
    const versionId = this.versionId;

    Vue.component('componentBoTexts', function (resolve, reject) {
      require([`@/components/texts/v1${articlePath}`], resolve)
    });
    Vue.component('componentTexts', function (resolve, reject) {
      require([`@/components/texts/v${versionId}${articlePath}`], resolve)
    });
  },
  methods: {
    ...mapMutations(['updateSelected', 'updateContraParent', 'updateTagClick', 'updateHasNoSameTag']),
    playOnIos: function(event) {
      this.$refs.audioFileL.play();
      this.$refs.audioFileL.pause();
      this.$refs.audioFileR.play();
      this.$refs.audioFileR.pause();
    },
    stopMP3: function(end, mp3File, startTime) {
      
      setTimeout(function () {
        mp3File.play();
      }, 500);

      const tillEnd = function() {
         if(mp3File.currentTime > end) {

             mp3File.pause();

           mp3File.removeEventListener('timeupdate', tillEnd);
         }
       }

       mp3File.addEventListener('timeupdate', tillEnd);
    },
  },
  watch: {
    tagClick: function() {

    const self = this;

      let startTime;
      let endTime;
      let mp3File;
    const checkData = () => {
      if (self.read === 'yes'){
      let mp3fileName = 'v1s1';

      switch (self.picked) {
        case 'paragraph':
          mp3fileName += 'to1';
        break;
        case 'phrase':
          mp3fileName += 'to2';
        break;
        default:
          mp3fileName += 'to3';
      }

      if (this.contraParent == 'left') {
          mp3fileName = 'v' + self.versionId + self.articlePath;
        } else {
          mp3fileName = 'v1' + self.articlePath;
        }
      if(self.mp3List.filter(item => item.mp3 == mp3fileName).length !== 0){

        let timeContent = self.mp3List.filter(item => item.mp3 == mp3fileName)[0].timeContent || null;
        timeContent = timeContent.filter(item => item.tag == self.selected);

      if (timeContent.length && timeContent[0] !== undefined) {

      const startTime = timeContent[0].start;
      const endTime = timeContent[0].end;
      if (self.contraParent == 'left') {
          mp3File = self.$refs.audioFileR;
          self.$refs.audioFileL.muted = true;
        } else {
          mp3File = self.$refs.audioFileL;
          self.$refs.audioFileR.muted = true;
        }
        mp3File.currentTime = startTime;
        mp3File.muted = false;

        return {mp3File, startTime, endTime};
      }
        }
      }
    }

      const clickPlay = async () => {
        return await checkData();
      }

      clickPlay()
          .then((res) => {

      const stopMP3 = (end, mp3File, startTime) => {

      mp3File.play();

      setTimeout(function () {
        mp3File.play();
      }, 500);

      const tillEnd = () => {
         if(mp3File.currentTime > end) {
             mp3File.pause();

           mp3File.removeEventListener('timeupdate', tillEnd);
         }
       }

       mp3File.addEventListener('timeupdate', tillEnd);
    }


        stopMP3(res.endTime, res.mp3File, res.startTime);
      });

    },
    picked: function() {
      this.updateTagClick(true);
      this.updateContraParent(0);
      this.updateSelected(null);
      this.updateHasNoSameTag(false);
      this.$refs.audioFileL.muted = true;
      this.$refs.audioFileR.muted = true;
    },
    articlePath: function() {
      const articlePath = this.articlePath + '.vue';
      const versionId = this.versionId;
      Vue.component('componentBoTexts', function (resolve, reject) {
        require([`@/components/texts/v1${articlePath}`], resolve)
      });
      Vue.component('componentTexts', function (resolve, reject) {
        require([`@/components/texts/v${versionId}${articlePath}`], resolve)
      });
    },
  },
  mounted() {
    this.$store.dispatch('getVersionList');
    this.$store.dispatch('getSutraList');
    this.$store.dispatch('getMp3List');
    this.updateTagClick(true);
    this.updateContraParent(0);
    this.updateSelected(null);
    this.updateHasNoSameTag(false);
  },
  computed: {
    ...mapState(['selected', 'contraParent', 'tagClick', 'hasNoSameTag']),
    hasContra() {
      let k = this.selected

      return k;
    },
    mp3LeftPicked() {
      let leftPick = (this.picked === 'paragraph'? 'to1':'to2' );
      return leftPick;
    },
    mp3LinkL() {
      let leftPick = (this.picked === 'paragraph'? 'to1':'to2' );
      let mp3name = '/static/mp3/v1s'
        + this.$route.params.sid + this.mp3LeftPicked + '.mp3';
      return mp3name;
    },
    mp3LinkR() {
      const rightPick = (this.picked === 'paragraph'? 'to1':'to2' );
      let mp3name = '/static/mp3/v' + this.$route.params.vid
        + 's' + this.$route.params.sid + rightPick +  '.mp3';
      return mp3name;
    },
    versionId() {
      return this.$route.params.vid;
    },
    sutraId() {
      return this.$route.params.sid;
    },
    versionList() {
      return this.$store.state.versionList;
    },
    sutraList() {
      return this.$store.state.sutraList;
    },
    versions() {
      return this.$store.getters.versions;
    },
    sutraId() {
      return this.$route.params.sid;
    },
    mp3List() {
      return this.$store.state.mp3List;
    },
    filteredVersionList() {
      let versionList = [...this.versionList];
      const nowVersionId = Number(this.versionId);

      if (nowVersionId !== '') {
        versionList = versionList.filter(item => item.id === nowVersionId);
      }

      return versionList;
    },
    filteredSutraList() {
      let listSutra = [...this.sutraList];
      const nowSutraId = Number(this.sutraId);

      if (nowSutraId !== '') {
        listSutra = listSutra.filter(item => item.sutraId === nowSutraId);
      }

      return listSutra;
    },
    filteredSutraVersionList() {
      let sutraList = [...this.filteredVersionList];

      if (sutraList.length !== 0) {
        sutraList = this.filteredVersionList[0].contents;
      }

      return sutraList;
    },
    articlePath() {
      let articlePath = '';
      switch (this.picked) {
        case 'paragraph':
          articlePath = `s${this.sutraId}to1`;
          break;
        case 'phrase':
          articlePath = `s${this.sutraId}to2`;
          break;
        case 'words':
          articlePath = `s${this.sutraId}to3`;
          break;
        case 'annotation':
          articlePath = `s${this.sutraId}to4`;
          break;
        default:
          articlePath = '';
      }

      return articlePath;
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#contra {
  text-align: left;
  padding: 20px;

  .content {
  display: flex;
  border: 1px solid black;
  margin: 40px 20px;
  min-height: 500px;
  height: 600px;
  }
  .hasNoSameTagMobile {
    display: none;
  }
  .hasNoSameTag{
    margin-right: 20px;
    float: right;
    background: rgb(233, 129, 129);
    padding-left: 20px;
    padding-right: 20px;
    color: #ffffff;
  }
  #left {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid black;
  }

  #right {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid black;
  }

  .mp3 {
    flex: initial;
    audio {
      display: none;
    }
    .button {
      background: #dee8c8;
      color: rgb(45, 42, 43);
      border: 1px solid #c2cbae;
      padding: 5px 8px;
    }
    .button:hover {
      background: #e9f4d1;
      color: rgb(45, 42, 43);
      border: 1px solid #c2cbae;
      text-decoration: none;
    }

  }

  @media (max-width: 768px) {

    .breadcrumb {
      .breadcrumb-item {
        font-size: 0.7em;
      }
    }

    .hasNoSameTag {
      display: none;
    }

    .topArea {
      div:first-child {
        float: left;
      }
      div:nth-child(2) {
        float: right;
      }
    }

    .content {
      clear: both;
      flex-direction: column;
      margin: 40px 0px;
      #left {
        flex: 1;
        overflow: scroll;
        -webkit-overflow-scrolling : touch;
      }
      #right {
        flex: 1;
        overflow: scroll;
        -webkit-overflow-scrolling : touch;
      }
      .hasNoSameTagMobile {
        display: block;
        background-color: #0f5022;
        padding: 4px 0px;
        color: white;
        font-weight: 600;
        text-align: center;
      }
    }

    .mp3 {
      display: none;
    }
  }
}



</style>


// WEBPACK FOOTER //
// src/components/Contra.vue